import { useContext } from 'react'

import { Dialog, DialogContent } from '@/components/dialog/dialog'

import { RegisterCaseDialogContext } from '../../../context'
import { Content } from './content/content'

interface Props {
  open: boolean
  onRegistered: (isEoir: boolean) => void
}

export const RegisterCaseDialog: React.FC<Props> = ({ open, onRegistered }) => {
  const { closeDialog } = useContext(RegisterCaseDialogContext)

  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          closeDialog()
        }
      }}
    >
      <DialogContent
        onPointerDownOutside={(e) => {
          e.preventDefault()
        }}
      >
        <Content onRegistered={onRegistered} />
      </DialogContent>
    </Dialog>
  )
}
